/**
 * Mantiene sincronizada la variante elegida en el selector del producto con los
 * formularios /cart/add.
 *
 * El JS principal del tema (shrine.null.js) esta vacio, asi que <variant-selects>
 * nunca se define y al cambiar de variante nadie actualiza el input "id" de los
 * formularios. Releasit COD Form lee ese input, por eso el formulario de pago
 * siempre se abria con la primera variante.
 */
(function () {
  if (window.variantSyncLoaded) return;
  window.variantSyncLoaded = true;

  function getVariants(picker) {
    const json = picker.querySelector('script[type="application/json"]');
    if (!json) return [];
    try {
      return JSON.parse(json.textContent);
    } catch (e) {
      return [];
    }
  }

  function getSelectedOptions(picker) {
    return Array.from(picker.querySelectorAll('select, input[type="radio"]:checked'), (el) => el.value);
  }

  function findVariant(variants, options) {
    return (
      variants.find(
        (variant) =>
          variant.options.length === options.length && variant.options.every((value, i) => value === options[i])
      ) || null
    );
  }

  function updateUrl(picker, variant) {
    if (picker.dataset.updateUrl === 'false' || window.location.pathname.indexOf('/products/') === -1) return;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  }

  function sync(picker, changedByUser) {
    const variants = getVariants(picker);
    const variant = findVariant(variants, getSelectedOptions(picker));
    if (!variant) return;

    // Solo los formularios de este producto: su id actual es el de alguna de sus variantes.
    const variantIds = variants.map((v) => String(v.id));
    document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((input) => {
      if (variantIds.includes(input.value)) input.value = variant.id;
    });

    if (changedByUser) updateUrl(picker, variant);
  }

  function syncAll() {
    document.querySelectorAll('variant-selects').forEach((picker) => sync(picker, false));
  }

  document.addEventListener('change', (event) => {
    const picker = event.target.closest && event.target.closest('variant-selects');
    if (picker) sync(picker, true);
  });

  // Al volver a la pagina o recargar, el navegador puede restaurar el radio marcado sin tocar el input id.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAll);
  } else {
    syncAll();
  }
  window.addEventListener('pageshow', syncAll);
})();
